import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button, CircularProgress } from "@material-ui/core";

const styles = (theme) => ({
  dialogFooter: {
    display: "flex",
    alignItems: "flex-end",
    paddingLeft: "24px",
    flexDirection : "column"
  },
  submitButton: {
    marginLeft: 16,
    minWidth: 140,
    '&$disabledButton': {
      backgroundColor: theme.disabledColor,
      color: theme.TextColor,
      opacity: 0.8
    }
  },
  circularProgress: {
    color: theme.white,
  },
  disabledText : {
    color : theme.error,
    fontSize : theme.textFontSize,
    marginTop : 4
  },
  disabledButton: {}
});

const PanelAction = (props) => {
  const {
    classes,
    handleClose,
    confirmButtonText,
    handleSubmit,
    isLoading,
    isDisabled,
    closeButtonText = "Cancel",
    disableMsg,
  } = props;
  return (
    <div className={classes.dialogFooter}>
      <div>
        <Button autoFocus onClick={handleClose} color="primary" variant="outlined">
          {closeButtonText}
        </Button>
        <Button
          autoFocus
          color="primary"
          variant="contained"
          onClick={!isLoading ? handleSubmit : null}
          classes={{
            root: classes.submitButton,
            disabled: classes.disabledButton
          }}
          disabled={isDisabled}>
          {isLoading ? (
            <CircularProgress size={24} classes={{ root: classes.circularProgress }} />
          ) : (
            confirmButtonText
          )}
        </Button>
      </div>
      {isDisabled && <div className={classes.disabledText}>{disableMsg}</div>}
    </div>
  );
};

export default withStyles(styles)(PanelAction);
